import type { SVGProps } from "react";
const SenecPictogramOrder = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path d="M28 11H30V9H28V11Z" fill="currentColor" />
        <path d="M32 11H34V9H32V11Z" fill="currentColor" />
        <path d="M36 11H38V9H36V11Z" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 6C7.34315 6 6 7.34315 6 9V32C6 32.5523 6.44772 33 7 33C7.55228 33 8 32.5523 8 32V14H40V39C40 39.5523 39.5523 40 39 40H9C8.44772 40 8 39.5523 8 39V37C8 36.4477 7.55228 36 7 36C6.44772 36 6 36.4477 6 37V39C6 40.6569 7.34315 42 9 42H39C40.6569 42 42 40.6569 42 39V9C42 7.34315 40.6569 6 39 6H9ZM40 12H8V9C8 8.44772 8.44772 8 9 8H39C39.5523 8 40 8.44772 40 9V12Z"
            fill="currentColor"
        />
        <path d="M16 17H11V19H16V17Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M19 17V23H37V17H19ZM21 21V19H35V21H21Z" fill="currentColor" />
        <path d="M11 23H16V21H11V23Z" fill="currentColor" />
        <path d="M16 25H11V27H16V25Z" fill="currentColor" />
        <path d="M28 25H19V27H28V25Z" fill="currentColor" />
        <path
            d="M32.5978 34.703L34.4388 33.9216L33.6574 32.0806L35.4984 31.2991L30.0017 26.0278L29.9754 33.6435L31.8164 32.862L32.5978 34.703Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramOrder;
